import { formatInTimeZone } from 'date-fns-tz';
import { enGB } from 'date-fns/locale/en-GB';
import { RouteStatus } from '../types/api/index';
import { RteContentType } from '../types/RteContentType';
import { timezone } from '../envVariables';

export const mapStatusToRteContent = (item: RouteStatus): RteContentType => ({
  title: item.title,
  htmlContent: item.detail,
  lastUpdatedMs: Date.parse(item.updatedAtDateTime),
  lastUpdated: formatInTimeZone(Date.parse(item.updatedAtDateTime), timezone, 'dd MMM yyyy HH:mm', { locale: enGB }),
  nextReview: item.nextReviewDateTime
    ? formatInTimeZone(Date.parse(item.nextReviewDateTime), timezone, 'dd MMM yyyy HH:mm', { locale: enGB })
    : undefined,
  disruptionReason: item.disruptionReason,
});
